import {AutoRefreshTokenService, createInterceptorCondition, INCLUDE_BEARER_TOKEN_INTERCEPTOR_CONFIG, IncludeBearerTokenCondition, provideKeycloak, UserActivityService, withAutoRefreshToken} from 'keycloak-angular';

const urlCondition = createInterceptorCondition<IncludeBearerTokenCondition>({
  urlPattern: new RegExp(String.raw`^${window.location.origin}\/?.*$`, "i"),
  bearerPrefix: 'Bearer'
});

export function providePiensoAuthorization(basePath: string='') {
  const provider = provideKeycloak({
    config: {
      url: `${window.location.origin}/auth/`,
      realm: 'Pienso',
      clientId: 'angular-web',
    },
    initOptions: {
      // TODO: Try this to avoid the extra roundtrips!
      onLoad: 'check-sso',
      silentCheckSsoRedirectUri: window.location.origin + basePath + '/assets/silent-check-sso.html',
      // onLoad: 'login-required',
      // checkLoginIframe: true
    },
    features: [
      withAutoRefreshToken({
          onInactivityTimeout: 'logout',
          sessionTimeout: 24*60*60*1000
      })
    ],
    providers: [
      UserActivityService,
      AutoRefreshTokenService,
      {
        provide: INCLUDE_BEARER_TOKEN_INTERCEPTOR_CONFIG,
        useValue: [urlCondition]
      }
    ]
  });
  return provider;
}
